"use strict";

exports.__esModule = true;
exports.DeviceTableElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _DeviceTableElement = require("./DeviceTableElement.legacy");
var _DeviceTableElement2 = require("./DeviceTableElement.modern");
// Flag-gated UI: `DeviceTableElement.legacy` is the component as it is on master,
// `DeviceTableElement.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var DeviceTableElement = exports.DeviceTableElement = (0, _uiSwitch.uiSwitch)(_DeviceTableElement.DeviceTableElement, _DeviceTableElement2.DeviceTableElement, "DeviceTableElement");